/*
 * @Author: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @Date: 2023-11-27 11:09:33
 * @LastEditors: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @LastEditTime: 2024-06-20 10:55:37
 * @FilePath: /front-vps-admin/src/main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import "babel-polyfill";
import 'default-passive-events';
import Vue from "vue";
import "normalize.css/normalize.css"; // a modern alternative to CSS resets

import '@/web-framework/assets/styles/index.css'//引入换肤css

// 输出编译环境
import Element from "element-ui";
//import Config from "./config/config." + env;
import "@/web-framework/assets/styles/element-variables.scss";
import '@/web-framework/assets/styles/variables.scss' // global css
import '@/web-framework/assets/styles/index.scss' // global css
import '@/web-framework/assets/styles/web.less' // global css
import '@/web-framework/assets/styles/admin.less' // global css
import '@/web-framework/assets/fonts/glyphicon/glyphicon.less';
import '@/web-framework/assets/fonts/font-awesome/less/font-awesome.less';
import '@/web-framework/assets/fonts/iconfont/iconfont.css';
import '@/web-framework/assets/styles/theme.less'//引入换肤css

import App from "@/web-framework/pages/App.vue";
import store from "./public/store";
import router from "./public/router";

import "@/web-framework/components/SvgIcon/icons/index.js"; // icon
import "./public/filter"; // permission control

import "@/web-framework/api/request";
import "@/web-framework/utils/prototype";

import Constants from "@/public/api/constants";
import { Utils } from "@/web-framework/api/utils";
import { isEmpty } from "lodash";
import Nodata from "@/web-framework/components/Nodata/index.vue";
import hpage from "@/web-framework/components/HuxgPagination/index.vue";
import YushuLogo from "@/web-framework/components/YushuLogo/index.vue";
import YushuDatadicForm from '@/web-framework/components/YushuDatadicForm/index.vue';
import YushuFormSearch from '@/web-framework/components/YushuFormSearch/index.vue';
import YushuListPage from '@/web-framework/components/YushuListPage/index.vue';
import YushuDatadicField from '@/web-framework/components/YushuDatadicField/index.vue';
import DlgImportError from '@/web-framework/components/ImportErrorDialog/index.vue';
import YushuSendMessage from '@/web-framework/components/YushuSendMessage/index.vue';
import YushuUploadFile from '@/web-framework/components/YushuUploadFile/index.vue';
import YushuUploadImage from '@/web-framework/components/YushuUploadImage/index.vue';
import YushuAudio from '@/web-framework/components/YushuAudio/index.vue';
import login from '@/web-framework/components/YushuLogin/install.js';
import editDialog from '@/web-framework/components/YushuDatadicEditDialog/install.js';
import YushuImage from '@/web-framework/components/YushuImage/index.vue';
import YushuAvator from "@/web-framework/components/YushuUserAvator/index.vue";
import YushuShare from "@/web-framework/components/YushuShare/index.vue";
import YushuSidebar from "@/web-framework/components/YushuSidebar/index.vue";
import YushuCkplayer from "@/web-framework/components/YushuCkplayer/index.vue";
import TableContainer from "@/web-framework/components/TableContainer/index.vue";
import OrganSelector from "@/web-framework/components/OrganSelector/index.vue";
import CustomerSelector from "@/web-framework/components/CustomerSelector/index.vue";
import TableInfoList from "@/web-framework/components/TableInfoList/index.vue";
import YushuArea from "@/web-framework/components/YushuAreaCascader";

window.Vue = Vue;
window.isEmpty = isEmpty;
window.Constants = Constants;

Vue.prototype.Constants = Constants;
Vue.prototype.Utils = Utils;
Vue.prototype.$login = login.install;
Vue.prototype.$editDialog = editDialog.install;

Vue.use(Element);

//全局组件挂载
Vue.component("hpage", hpage);
Vue.component("Nodata", Nodata);
Vue.component("YushuLogo", YushuLogo);
Vue.component("YushuDatadicForm", YushuDatadicForm);
Vue.component("YushuFormSearch", YushuFormSearch);
Vue.component("YushuListPage", YushuListPage);
Vue.component("YushuDatadicField", YushuDatadicField);
Vue.component("DlgImportError", DlgImportError);
Vue.component("DlgSendMessage", YushuSendMessage);
Vue.component("YushuUploadFile", YushuUploadFile);
Vue.component("YushuUploadImage", YushuUploadImage);
Vue.component("YushuAudio", YushuAudio);
Vue.component("YushuImage", YushuImage);
Vue.component("YushuAvator", YushuAvator);
Vue.component("YushuShare", YushuShare);
Vue.component("YushuSidebar", YushuSidebar);
Vue.component("YushuCkplayer", YushuCkplayer);
Vue.component("TableContainer", TableContainer);
Vue.component("OrganSelector", OrganSelector);
Vue.component("TableInfoList", TableInfoList);
Vue.component("YushuArea", YushuArea);
Vue.component("CustomerSelector", CustomerSelector);


Vue.config.productionTip = false;

new Vue({
    el: "#app",
    router,
    store,
    render: h => h(App)
});
